import { forwardRef, memo } from 'react'

import * as icons from './icons'
import * as SC from './styled'
import { IconProps } from './types'

export * from './types'

const Icon = forwardRef<SVGSVGElement, IconProps>(
  (
    {
      className,
      icon,
      color,
      width,
      height,
      preserveAspectRatio,
      onClick,
      title,
    },
    ref
  ) => {
    const { viewBox, id } = icons[icon]
    const symbolId = id?.replace('-usage', '') ?? ''

    return (
      <SC.Container
        ref={ref}
        className={className}
        $color={color}
        viewBox={viewBox}
        {...(color && { color })}
        {...(width && { width })}
        {...(height && { height })}
        {...(preserveAspectRatio && { preserveAspectRatio })}
        {...(onClick && { onClick })}
        {...(!onClick && !title && { 'aria-hidden': true })}
      >
        {title && <title>{title}</title>}
        <use xlinkHref={`#${symbolId}`} href={`#${symbolId}`} />
      </SC.Container>
    )
  }
)

Icon.displayName = 'Icon'

export default memo(Icon)
